import { FREECUT_STUDIO_FEATURE } from './feature';

/**
 * Who may open FreeCut Studio (`/clips/:id/freecut`): plans or subscriptions with the
 * `freecut_studio` feature, and every admin. The studio is gated in the app only; the backend
 * serves a clip's render data to its owner either way.
 */
export const hasFreecutStudioAccess = ({
  features,
  isAdmin,
}: {
  features: readonly string[] | null | undefined;
  isAdmin: boolean | null | undefined;
}): boolean => isAdmin === true || (features ?? []).includes(FREECUT_STUDIO_FEATURE);
